// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationSampleId } from './FermentationSample';
import { fileStorageId } from './FileStorage';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationSampleImageId = (z.number());
export const fermentationSampleImage = z.object({
    id: fermentationSampleImageId,
    fermentation_sample_id: fermentationSampleId,
    file_storage_id: fileStorageId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationSampleImageInitializer = z.object({
    id: fermentationSampleImageId.optional(),
    fermentation_sample_id: fermentationSampleId,
    file_storage_id: fileStorageId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationSampleImageMutator = z.object({
    id: fermentationSampleImageId.optional(),
    fermentation_sample_id: fermentationSampleId.optional(),
    file_storage_id: fileStorageId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationSampleImage.js.map